import React from 'react';
export var bankTransfers = function (isMenuItem) { return ({
    type: 'link',
    content: isMenuItem ? 'Bank Transfers' : 'Transfers',
    url: '/payments/transfers',
    key: 'bankTransfers',
}); };
export var investTransfers = function (isMenuItem) { return ({
    type: 'link',
    content: isMenuItem ? 'Invest Transfers' : 'Transfers',
    url: '/ext-invest-live/transfer',
    key: 'investTransfers',
}); };
var zelleLink = {
    type: 'link',
    content: (React.createElement(React.Fragment, null,
        "Zelle",
        React.createElement("sup", null, "\u00AE"))),
    url: '/payments/pay-people',
    key: 'zelle',
};
var billPayLink = {
    type: 'link',
    content: 'Bill Pay',
    url: '/payments/pay-bills',
    key: 'billPayLink',
};
var sendWireLink = function (isHiddenMobile) { return ({
    type: 'link',
    content: 'Wires',
    url: '/payments/send-wire',
    key: 'wires',
    isHiddenMobile: isHiddenMobile,
}); };
export var creditCardLink = {
    type: 'link',
    content: 'Credit Cards',
    url: '/sso/credit-card/ePay/MakePayment',
    key: 'creditCard',
    metadata: {
        withAllyTM: 'payments-creditCards',
    },
};
export var homeLoansButton = function (redirectToMortgage) {
    return {
        type: 'button',
        content: 'Home Loans',
        key: 'homeLoansLink',
        onClick: redirectToMortgage,
    };
};
export var vehiclePaymentsLink = {
    type: 'link',
    content: 'Vehicle Payments',
    url: '/sso/auto/payments',
    key: 'vehiclePayments',
};
export var combinedTransfers = function (isNewPaymentsNavEnabled, isWiresHiddenInMobile) {
    var items = [investTransfers(true), bankTransfers(true)].concat(isNewPaymentsNavEnabled
        ? [zelleLink, sendWireLink(isWiresHiddenInMobile)]
        : []);
    return {
        type: 'menu',
        triggerContent: 'Transfers',
        items: items,
        key: 'combinedTransfers',
    };
};
export var bankOnlyTransfers = function (isNewPaymentsNavEnabled, isWiresHiddenInMobile) {
    return isNewPaymentsNavEnabled
        ? {
            type: 'menu',
            triggerContent: 'Transfers',
            items: [
                bankTransfers(true),
                zelleLink,
                sendWireLink(isWiresHiddenInMobile),
            ],
            key: 'bankOnlyTransfers',
        }
        : bankTransfers();
};
export var getPaymentsDropdownItems = function (isNewPaymentsNavEnabled, isWiresHiddenInMobile) {
    return [billPayLink, zelleLink].concat(isNewPaymentsNavEnabled ? sendWireLink(isWiresHiddenInMobile) : []);
};
export var deposits = {
    type: 'link',
    content: 'Deposits',
    url: '/payments/deposit-checks',
    key: 'deposits',
};
export var WealthOverviewLink = {
    type: 'link',
    content: 'Wealth Overview',
    url: '/ext-wealth/wealth-overview',
    key: 'wealthOverviewLink',
};
export var investmentsLink = {
    type: 'link',
    content: 'Investments',
    url: '/ext-invest-live/dashboard',
    key: 'investmentsLink',
};
export var getManageCDsItem = function (isHiddenMobile) { return ({
    type: 'link',
    content: 'Manage CDs',
    url: '/bank/manage-cds',
    key: 'manageCDs',
    isHiddenMobile: isHiddenMobile,
}); };
export var getManageIRAsItem = function (isHiddenMobile) { return ({
    type: 'link',
    content: 'Manage IRAs',
    url: '/bank/manage-ira',
    key: 'manageIRAs',
    isHiddenMobile: isHiddenMobile,
}); };
export var bankStatements = {
    type: 'link',
    content: 'Bank Statements',
    url: '/bank/statements-and-forms',
    key: 'bankStatements',
};
export var investStatements = {
    type: 'link',
    content: 'Investments',
    url: '/ext-invest-live/accounts/activity-documents?documents=true',
    key: 'investStatements',
};
export var bankDocuments = {
    type: 'link',
    content: 'Bank Accounts',
    url: '/bank/statements-and-forms',
    key: 'bankStatements',
};
export var bankTaxForms = {
    type: 'link',
    content: 'Bank Tax Forms',
    url: '/bank/statements-and-forms/tax',
    key: 'bankTaxForms',
};
export var investDocuments = {
    type: 'link',
    content: 'Investment Documents',
    url: '/ext-invest-live/accounts/activity-documents?documents=true',
    key: 'investDocuments',
};
export var ccStatements = {
    type: 'link',
    content: 'Credit Cards',
    url: '/sso/credit-card/Account/OnlineStatement',
    key: 'ccStatements',
    metadata: {
        withAllyTM: 'statements-creditCards',
    },
};
export var homeLoansStatementsButton = function (redirectToMortgage) {
    return {
        type: 'button',
        content: 'Home Loans',
        key: 'homeLoansStatements',
        onClick: redirectToMortgage,
    };
};
export var statementDropdown = function (shownItems) {
    return {
        type: 'menu',
        triggerContent: 'Statements',
        items: shownItems,
        key: 'statements',
    };
};
export var documentDropdown = function (shownItems) {
    return {
        type: 'menu',
        triggerContent: 'Documents',
        items: shownItems,
        key: 'documents',
    };
};
export var taxForms = {
    type: 'link',
    content: 'Tax Forms',
    url: '/bank/statements-and-forms/tax',
    key: 'taxForms',
};
export var vehicleDocuments = function (id) {
    return {
        type: 'link',
        content: 'Vehicle Documents',
        url: "/sso/auto/document-center/" + id + "/all-documents",
        key: 'vehicleDocuments',
    };
};
export var directDeposit = {
    type: 'link',
    content: 'Direct Deposit',
    url: '/direct-deposit',
    key: 'directDeposit',
};
export var checkDeposits = {
    type: 'link',
    content: 'Check Deposits',
    url: '/payments/deposit-checks',
    key: 'checkDeposits',
};
//# sourceMappingURL=items.js.map